import React from 'react';
import PropTypes from 'prop-types';
import {Icon, IconButton} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    groupIcon: {
        position: 'absolute',
        top: '4px',
        left: '2px'
    },
    icon: {fontSize: 20},
}));

const AddArrayButton = (props) => {
    const {path, valueIndex, openGroupMenu, previewMode} = props;
    const classes = useStyles();
    return (
        <IconButton color={"default"}
                    variant={"text"}
                    disabled={previewMode}
                    style={{padding: 0}}
                    className={classes.groupIcon}
                    onClick={(event) => openGroupMenu(event, valueIndex, path)}
        >
            <Icon style={{fontSize: 20}} className={classes.icon}>add</Icon>
        </IconButton>
    )
};

export default AddArrayButton

AddArrayButton.propTypes = {
    valueIndex: PropTypes.number,
    path: PropTypes.string,
    openGroupMenu: PropTypes.func,
    previewMode: PropTypes.bool
};